import { NavLink } from "react-router-dom";
import { Home, Users, Play, Rss } from "lucide-react";

const items = [
  { to: "/", icon: Home, label: "Home", testid: "nav-home" },
  { to: "/feed", icon: Rss, label: "Feed", testid: "nav-feed" },
  { to: "/record", icon: Play, label: "Los", testid: "nav-record", center: true },
  { to: "/friends", icon: Users, label: "Freunde", testid: "nav-friends" },
  { to: "/profile", icon: null, label: "Profil", testid: "nav-profile", avatar: true },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 w-full z-[1000] backdrop-blur-xl bg-black/70 border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="max-w-lg mx-auto flex items-center justify-around px-2 py-2">
        {items.map(({ to, icon: Icon, label, testid, center, avatar }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className="flex flex-col items-center justify-center gap-1 min-w-[56px] min-h-[52px]"
          >
            {({ isActive }) =>
              center ? (
                <>
                  <span className="flex items-center justify-center w-14 h-14 -mt-8 rounded-full border-4 border-[#0A0A0A] bg-[#CCFF00] transition-transform active:scale-95">
                    <Play className="w-7 h-7 text-black" fill="black" />
                  </span>
                  <span className="text-[10px] font-bold text-[#CCFF00]">{label}</span>
                </>
              ) : avatar ? (
                <>
                  <span
                    className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-black transition-colors ${
                      isActive ? "bg-[#CCFF00] text-black" : "bg-[#1A1A1A] text-neutral-500 border border-white/10"
                    }`}
                  >
                    P
                  </span>
                  <span className={`text-[10px] font-semibold transition-colors ${isActive ? "text-[#CCFF00]" : "text-neutral-500"}`}>
                    {label}
                  </span>
                </>
              ) : (
                <>
                  <Icon className={`w-6 h-6 transition-colors ${isActive ? "text-[#CCFF00]" : "text-neutral-500"}`} />
                  <span className={`text-[10px] font-semibold transition-colors ${isActive ? "text-[#CCFF00]" : "text-neutral-500"}`}>
                    {label}
                  </span>
                </>
              )
            }
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
